module.exports = __webpack_public_path__ + "static/img/12006A_1_2_C_20210322_LC.11849c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12006A_1_2_C_20210322_LC.png
// module id = Xcif
// module chunks = 0